$(document).on('turbolinks:load', function () {
  if ($("#purchasing-agencies-table").length) {
    $('#purchasing-agencies-table').DataTable({
      searching: true,
      serverSide: true,
      aLengthMenu: [
        [10, 25, 50, 100, 200],
        [10, 25, 50, 100, 200]
      ],
      iDisplayLength: 10,
      language: {
        "sLengthMenu": "Showing_MENU_",
        "info": "of _TOTAL_ Purchasing Organizations",
        "oPaginate": {
          "sFirst": "",
          "sLast": ""
        }
      },
      ajax: {
        url: $("#purchasing-agencies-table").data('source'),
      },
      pagingType: "full_numbers",
      "dom": "<'table-top'f><'table-responsive'rt><'table-bottom'<'table-count-info'li>p>",
      columns: [
        { data: "name" },
        { data: 'updated_at' },
        {
          data: "links",
          className: 'text-center social-links',
          orderable: false
        },
        {
          data: "dt_actions",
          className: 'icon-wrap',
          orderable: false
        },
      ]
    });
  }
})
